import { compose, prop, find, propEq } from 'ramda'
import { signalTranslation } from 'i18n/displayConstants/signals'
import { TRANSLATION_TYPES } from 'utils/constants'

export const translationValue = (value, translationType, translations) => {
  const translation = compose(
    signalTranslation,
    prop('translation'),
    find(propEq('value', value))
  )

  return TRANSLATION_TYPES.has(translationType) && translations
    ? translation(translations)
    : value
}
